import styled from '@emotion/styled'
import { css } from '@emotion/core'

const BlockShownStyling = props => (props.type === 'block' && props.isPopoverShown) &&
  css`
  background-color: #fff;
  opacity: 1;
  padding: 5px;
`

const BlockStyling = props => (props.type === 'block') &&
  css`
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`

const TriggerWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  opacity: .8;
  cursor: pointer;
  user-select: none;
  transition: opacity .1s ease, padding .2s ease, background-color .3s ease;

  &:hover {
    opacity: 1;
  }
  
  ${BlockShownStyling}
  ${BlockStyling}
`

export default TriggerWrapper
